import { ActivityEntityName, AssetTypeEntity, EntitySubStatus } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.Asset,
    name: 'AssetMergeSchema',
})
export class AssetMergeData {
    @MergeField()
    assetNumber: string;

    @MergeField()
    name: string;

    @MergeField()
    assetType: string;

    @MergeField()
    lastServicedJob: string;

    @MergeField()
    lastServiceOn: string;

    @MergeField()
    status?: string;

    @MergeField()
    createdAt: string;

    @MergeField()
    childrenCount: number;
}

export const AssetMergeSchema = getSchema(AssetMergeData);